import useUpdate from "@taroify/hooks/use-force-update/index.js";
export default useUpdate;
